import React from 'react';
import Translate from 'react-translate-component';

class LoyaltyPointsOverviewIncluded extends React.Component {
  includedItems = [
    {
      icon: require('images/icons/credit-card.svg'),
      title: 'LOYALTY_ALWAYS_INCLUDED_FAST_PAYMENT'
    },
    {
      icon: require('images/icons/headset.svg'),
      title: 'LOYALTY_ALWAYS_INCLUDED_ADVICE'
    },
    {
      icon: require('images/icons/document.svg'),
      title: 'LOYALTY_ALWAYS_INCLUDED_HOTLINE'
    },
    {
      icon: require('images/icons/tags.svg'),
      title: 'LOYALTY_ALWAYS_INCLUDED_BENEFITS'
    }
  ];

  alwaysIncluded () {
    const alwaysIncluded = [];
    this.includedItems.forEach((item) => alwaysIncluded.push(
      <div key={item.title} className='loyalty-points-overview-included-item'>
        <img src={item.icon} />
        <Translate
          className='loyalty-points-overview-included-item-title'
          content={item.title} />
      </div>
    ));
    return alwaysIncluded;
  }

  render () {
    return (
      <div className='loyalty-points-overview-included'>
        <Translate
          className='loyalty-points-overview-included-title'
          content='LOYALTY_ALWAYS_INCLUDED_TITLE' />
        {this.alwaysIncluded()}
      </div>
    );
  }
}

export default LoyaltyPointsOverviewIncluded;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/overview/included.js
 **/